import React, { useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { ConfigProvider } from 'antd';
import moment, { localeMoment } from "utils/moment/momentLocale";

import en_US from 'antd/es/locale/en_US';
import fr_FR from 'antd/es/locale/fr_FR';
import de_DE from 'antd/es/locale/de_DE';

import 'moment/dist/locale/en-gb'; //english
import 'moment/dist/locale/fr'; //french
import 'moment/dist/locale/de'; //german

ConfigProvider.config({
  theme: {
    // primaryColor: '#005D72', // primary color for all components
    // linkColor: '#005D72', // link color
    'font-family': 'Roboto', // link color
  },
});

export const AppAntdTranslationProvider = ({ children }) => {
  const { i18n } = useTranslation();
  const lang = localStorage.getItem('i18nextLng') || process.env.DEFAULT_LANGUAGE || "fr";

  moment.locale(i18n?.language || lang);

  const localeAntd = {
    en: en_US,
    fr: fr_FR,
    de: de_DE,
  };

  useEffect(() => {
    moment.locale(i18n?.language);
    if (i18n?.language == "fr") {
      moment.updateLocale(i18n?.language, localeMoment);
    }
  }, [i18n?.language]);

  return (
    <ConfigProvider
      locale={localeAntd[i18n?.language || lang]}
      direction="ltr"
    >
      {children}
    </ConfigProvider>
  );
};

export default AppAntdTranslationProvider;